import React from 'react'

import axios from 'axios'
import { toast } from 'react-toastify'
import { businessApiURL, getCountryCode, getLanguageCode, getToken } from '../..'

export async function getPersonalDetails() {
  try {
    const res = await axios.get(
      `${businessApiURL}/api/secure/bc/details/personal?languageCode=${getLanguageCode()}&countryCode=${getCountryCode()}`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      },
    )
    return res
  } catch (err) {
    console.log(err)
    return err
  }
}

export async function updatePersonalDetails(updateBody) {
  try {
    const res = await axios.post(
      `${businessApiURL}/api/secure/professional/profile/update?languageCode=${getLanguageCode()}&countryCode=${getCountryCode()}`,
      updateBody,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      },
    )
    return res
  } catch (err) {
    console.log(err)
    toast.error('Something went wrong while updating the profile.')
    return err
  }
}
